import { fetchJSON as fetchAPI } from './client';

export type SprintDashboard = {
  sprint_id: string; objectives: number; intelligence_modules: number;
  provider_interfaces: number; background_jobs: number; quality_gates: number;
  backend_apis: number; database_tables: number; generated_at: string;
};

export type SprintValidation = {
  valid: boolean; every_asin_has_inventory_health: boolean; forecast_operational: boolean;
  scenario_planner_operational: boolean; shipment_simulator_operational: boolean;
  recommendations_from_dna: boolean; experiments_auto_created: boolean;
  marketplace_dna_updated: boolean; forecast_accuracy_measurable: boolean; gaps?: string[];
};

export type Dev108Status = {
  sprint_id: string; objectives: number; intelligence_modules: number;
  fba_growth_platform: boolean; production_ready: boolean; dna_integrated: boolean;
  forecast_accuracy_measurable: boolean; status: string;
};

const GOVERNANCE_BASE = import.meta.env.VITE_GOVERNANCE_API ?? '/api/v1/governance';
const fetchG = <T,>(path: string, init?: RequestInit) => fetchAPI<T>(`${GOVERNANCE_BASE}${path}`, init);

export const fbaGrowthIntelligenceDev108Api = {
  dashboard: () => fetchG<SprintDashboard>('/dev108/dashboard'),
  objectives: () => fetchG<{ objectives: { key: string; name: string; category: string }[] }>('/dev108/objectives').then((r) => r.objectives),
  intelligenceModules: () => fetchG<{ modules: { key: string; name: string; category: string }[] }>('/dev108/intelligence-modules').then((r) => r.modules),
  providers: () => fetchG<{ providers: { key: string; name: string; interface: string }[] }>('/dev108/service-architecture').then((r) => r.providers),
  backgroundJobs: () => fetchG<{ jobs: { key: string; name: string; schedule?: string }[] }>('/dev108/background-jobs').then((r) => r.jobs),
  qualityGates: () => fetchG<{ gates: { key: string; name: string; blocking: boolean }[] }>('/dev108/quality-gates').then((r) => r.gates),
  validate: (attrs: Record<string, boolean>) =>
    fetchG<SprintValidation>('/dev108/validate', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attrs }) }),
  status: () => fetchG<Dev108Status>('/dev108/status'),
};
